// src/icons/WalletSDKIcon.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function WalletSDKIcon() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "36",
      height: "33",
      viewBox: "0 0 36 33",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M32 7.5V7.5C32 6.10444 32 5.40666 31.8278 4.83886C31.44 3.56046 30.4395 2.56004 29.1611 2.17224C28.5933 2 27.8956 2 26.5 2H8.4C6.15979 2 5.03968 2 4.18404 2.43597C3.43139 2.81947 2.81947 3.43139 2.43597 4.18404C2 5.03968 2 6.15979 2 8.4V24.6C2 26.8402 2 27.9603 2.43597 28.816C2.81947 29.5686 3.43139 30.1805 4.18404 30.564C5.03968 31 6.15979 31 8.4 31H25.6C27.8402 31 28.9603 31 29.816 30.564C30.5686 30.1805 31.1805 29.5686 31.564 28.816C32 27.9603 32 26.8402 32 24.6V24.5",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsx("rect", { x: "24", y: "12", width: "12", height: "8", rx: "1", fill: "#7808D0" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M19 30C19 21.1634 11.8366 14 3 14",
            stroke: "currentColor",
            strokeWidth: "3"
          }
        )
      ]
    }
  );
}

export {
  WalletSDKIcon
};
